import { render, staticRenderFns } from "./Welcoming.vue?vue&type=template&id=35ced114"
import script from "./Welcoming.vue?vue&type=script&lang=js"
export * from "./Welcoming.vue?vue&type=script&lang=js"
import style0 from "./Welcoming.vue?vue&type=style&index=0&id=35ced114&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports